'use strict';

// Load jQuery
import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;

// Load Bootstrap 5
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Load Flatpickr - datetime picker
import flatpickr from 'flatpickr';
jQuery.fn.extend({
  flatpickr: function (opt) {
    flatpickr(this, opt);
  }
});
window.flatpickr = flatpickr;

// Load Select2 - replacement for select boxes
import select2 from "select2/dist/js/select2.full";
select2(jQuery);

// Load Swiper - The Most Modern Mobile Touch Slider
import Swiper from 'swiper/bundle';
window.Swiper = Swiper;

// Load ionRangeSlider - responsive range slider
import 'ion-rangeslider';

// Load Photoswipe 4 - JavaScript image gallery and lightbox
import PhotoSwipe from 'photoswipe/dist/photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
window.PhotoSwipe = PhotoSwipe;
window.PhotoSwipeUI_Default = PhotoSwipeUI_Default;